import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { FonteComercializadora } from '../../components'
import * as fonteComercializadoraActionCreators from '../../redux/modules/fonteComercializadora'
import * as flashMessageActionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class FonteComercializadoraContainer extends Component {

  static propTypes = {
    comercializadora: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,

    multipleFonteComercializadora: PropTypes.object.isRequired,
    fetchMultipleFonteComercializadora: PropTypes.func.isRequired,
    destroyFonteComercializadora: PropTypes.func.isRequired,

    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    hideFlashMessage: PropTypes.func,

    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string
  }

  async componentDidMount () {
    const { comercializadora } = this.props
    await this.props.fetchMultipleFonteComercializadora(comercializadora.id)
  }

  handleRedirectToNew = (comercializadoraId) => {
    this.props.history.push(`/comercializadoras/${comercializadoraId}/fontes_comercializadoras/new`)
  }

  handleEditResource = (comercializadoraId, id) => {
    this.props.history.push(`/comercializadoras/${comercializadoraId}/fontes_comercializadoras/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyFonteComercializadora(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('fonteComercializadora', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('fonteComercializadora', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleFonteComercializadora.toList().toJSON(),
      'fonteComercializadora',
      [
        'id',
        'comercializadora.nome',
        'fonte_energia.nome',
        'codigo_ccee',
      ],
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <FonteComercializadora
        comercializadora={this.props.comercializadora}
        multipleFonteComercializadora={this.props.multipleFonteComercializadora}
        onRedirectToNew={() => this.handleRedirectToNew(this.props.comercializadora.id)}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading}
      />
    )
  }
}

function mapStateToProps ({ fonteComercializadora, status, sort, filter }, {comercializadora}) {
  const sortColumn = sort.getIn(['fonteComercializadora', 'sortColumn']) || 'id'
  const sortDirection = sort.getIn(['fonteComercializadora', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['fonteComercializadora', 'filterText']) || ''

  let map = filterMap(fonteComercializadora, ['fonte_energia.nome', 'codigo_ccee'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleFonteComercializadora: map.filter(t => t.get('comercializadora_id') === comercializadora.id),
    error: status.getIn(['fonteComercializadora', 'error']),
    isLoading: status.getIn(['fonteComercializadora', 'isLoading']),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...fonteComercializadoraActionCreators,
    ...flashMessageActionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FonteComercializadoraContainer))
